import type { FieldValidator } from 'final-form'
import isEmpty from 'lodash/isEmpty'

export type RequiredValidatorOpts = {
	emptyValue?: any
	trimWhitespace?: boolean // trim strings before checks
}

const DEFAULTS: Required<RequiredValidatorOpts> = {
	emptyValue: '',
	trimWhitespace: true,
}

/** Validates that the field value is not empty (`!isEmpty`)*/
export const required =
	(errorText: string, opts: RequiredValidatorOpts = DEFAULTS): FieldValidator<any> =>
	(value: unknown) => {
		const o = { ...DEFAULTS, ...opts }

		if (value == null) return errorText
		if (typeof value == 'string') {
			return (o.trimWhitespace ? value.trim() : value) != o.emptyValue ? undefined : errorText
		}

		return isEmpty(value) && value != o.emptyValue ? errorText : undefined
	}
